import { render, staticRenderFns } from "./SupplierListAddNew.vue?vue&type=template&id=085a2e66&"
import script from "./SupplierListAddNew.vue?vue&type=script&lang=js&"
export * from "./SupplierListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./SupplierListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports